module.exports = __webpack_public_path__ + "img/yesOrNoEle.f2134afd.svg";